export default {
	title: "Data Import",
	subtitle: "Import consultants from XLSX spreadsheets",
	downloadTemplate: "Download Template",
	uploadFile: "Upload File",
	maxSize: "Maximum size: {size}MB",
	preview: "Preview",
	confirm: "Confirm Import",
	validRows: "{count} valid row(s)",
	invalidRows: "{count} row(s) with errors",
	totalRows: "{count} total row(s)",
	editableHint: "Review the names below. You can edit First Name and Last Name directly in the table before importing.",
	skippedRowsHint: "{count} row(s) with errors will not be imported. Fix and re-upload the spreadsheet or import these records later.",
	success: "{count} person(s) imported successfully",
	partialSuccess: "{imported} of {total} person(s) imported",
	goBack: "Go Back",
	errors: {
		fileTooLarge: "File too large. Maximum {size}MB",
		importFailed: "Failed to import data",
	},
	result: {
		title: "Import Result",
		viewConsultants: "View Consultants",
		importMore: "Import More",
	},
	steps: {
		upload: "Upload",
		preview: "Review",
		result: "Result",
	},
	template: {
		instructionsText: "Fill in the data following the template and upload the file for review.",
	},
};
